import { createSlice } from "@reduxjs/toolkit";

const depositSlice = createSlice({
  name: "deposit",
  initialState: {
    loading: false,
    depositPlans: [],
    subscribedPlans: [],
    subscribeResult: null,
    error: null,
    breakPlanResult: null,
  },
  reducers: {
    getDepositPlansRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getDepositPlansSuccess: (state, action) => {
      state.loading = false;
      state.depositPlans = action.payload.data || [];
    },
    getDepositPlansFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    subscribeDepositPlanRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    subscribeDepositPlanSuccess: (state, action) => {
      state.loading = false;
      state.subscribeResult = action.payload;
    },
    subscribeDepositPlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getSubscribedPlansRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSubscribedPlansSuccess: (state, action) => {
      state.loading = false;
      state.subscribedPlans = action.payload.data || [];
    },
    getSubscribedPlansFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    depositPlanBreakRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    depositPlanBreakSuccess: (state, action) => {
      state.loading = false;
      state.breakPlanResult = action.payload;
    },
    depositPlanBreakFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearBreakPlanResult: (state) => {
      state.breakPlanResult = null;
    },
  },
});

export const {
  getDepositPlansRequest,
  getDepositPlansSuccess,
  getDepositPlansFailure,
  subscribeDepositPlanRequest,
  subscribeDepositPlanSuccess,
  subscribeDepositPlanFailure,
  getSubscribedPlansRequest,
  getSubscribedPlansSuccess,
  getSubscribedPlansFailure,
  depositPlanBreakRequest,
  depositPlanBreakSuccess,
  depositPlanBreakFailure,
  clearBreakPlanResult,
} = depositSlice.actions;

export default depositSlice.reducer;
